import { render, staticRenderFns } from "./RelatedPoisTeaser.vue?vue&type=template&id=1050ef3b"
import script from "./RelatedPoisTeaser.js?vue&type=script&lang=js&external"
export * from "./RelatedPoisTeaser.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports